exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-dropdown.b-dropdown-open {\n\tposition: absolute;\n\tbottom: 100%;\n}\n", ""]);

// exports
